import SSEListenerAdapter from '../services/ListenerManager/adapters/SSEAdapter';

/**
 * Database Adapter Configuration
 *
 * ListenerManager: Server-Sent Events (SSEAdapter)
 */

// Adapter for ListenerManager (real-time subscriptions)
export const LISTENER_ADAPTER = SSEListenerAdapter;

/**
 * Database configuration options
 */
export const DATABASE_CONFIG = {
  // Add adapter-specific config here if needed
};
